import { createSetupError } from '../utils/error';
export function ClassNames(_) {
    throw createSetupError();
}
//# sourceMappingURL=index.js.map